import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/index.css";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// ✅ Handle redirect login response BEFORE rendering app
msalInstance.handleRedirectPromise().catch((error) => {
  console.error("🔁 MSAL redirect error:", error);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>
);
